import React, { useState, useEffect } from "react";
import {
  TrashIcon,
  ArrowLeftEndOnRectangleIcon,
} from "@heroicons/react/24/outline";
import Cookies from 'js-cookie';

const QuizList = () => {
  const [Quizzes, setQuizzes] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const user = JSON.parse(Cookies.get("user"));

  useEffect(() => {
    recentQuizz();
  }, []);

  const recentQuizz = async () => {
    try {
      const token = Cookies.get("token");
      const user = JSON.parse(Cookies.get("user"));
      const url = `${process.env.REACT_APP_ADDRESS}/quizes/${user._id}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.status === 200) {
        setQuizzes(data);
      } else if (response.status === 404) {
        setQuizzes([]);
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      console.error("Error fetching quizzes:", error);
    }
  };

  const handleViewQuiz = (quizId) => {
    setSelectedQuiz(quizId);
  };

  const handleDeleteQuiz = async (quizId) => {
    try {
      const token = Cookies.get("token");
      

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/quizes/${user._id}/${quizId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        setQuizzes(Quizzes.filter((quiz) => quiz._id !== quizId));
      } else {
        throw new Error(data.error || "Failed to delete quiz");
      }
    } catch (error) {
      console.error("Error deleting quiz:", error);
    }
  };

  return (
    <><h1 className="text-2xl font-semibold leading-7 text-gray-900 pb-4">
      Quizes
    </h1><h2 className="text-base font-semibold leading-7 pb-5 text-gray-900">
        Your Quiz List
      </h2><ul role="list" className="space-y-6">
        {Quizzes.map((quiz, index) => (
          <li
            key={index}
            className="bg-white p-6 shadow-lg rounded-xl border border-gray-200"
          >
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-x-3">
                  <p className="truncate text-2xl font-bold text-gray-900">
                    Quiz Result: Contract {quiz.result}
                  </p>
                </div>
              </div>
              <div className="flex mt-4 sm:mt-0 items-center gap-x-4">
                <a
                  href="#"
                  onClick={() => handleViewQuiz(quiz._id)}
                  className="inline-block rounded-md bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-md transition"
                >
                  View Quiz Answers
                </a>
                <button
                  onClick={() => handleDeleteQuiz(quiz._id)}
                  className="text-red-500 hover:text-red-700 transition"
                >
                  <TrashIcon className="h-6 w-6" />
                </button>
              </div>
            </div>
            {selectedQuiz === quiz._id && (
              <div className="mt-6 p-4 bg-gray-50 rounded-lg shadow-inner border border-gray-200">
                <h3 className="text-lg font-bold text-gray-700 mb-3">
                  Quiz Details:
                </h3>
                {quiz.suggestionsScore.length > 0 && (
                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-600">
                      Suggestion: Contract {quiz.result}
                    </h4>
                  </div>
                )}
                <div>
                  <h4 className="font-semibold text-gray-600"> Your Answers:</h4>
                  <ul className="list-disc list-inside text-gray-700 pl-4">
                    {quiz.answers.map((answer, answerIndex) => (
                      <li key={answerIndex}>{answer}</li>
                    ))}
                  </ul>
                </div>
                <button
                  onClick={() => setSelectedQuiz(null)}
                  className="mt-4 text-pink-600 hover:text-pink-700 flex items-center transition"
                >
                  <ArrowLeftEndOnRectangleIcon className="h-5 w-5 mr-1" />
                  Back
                </button>
              </div>
            )}
          </li>
        ))}
      </ul></>
  );
};

export default QuizList;
